import { NavItem, Select } from '@billy/design-system'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { RecurringInvoiceDelivery } from '@features/recurringInvoices/enums/recurringInvoiceDelivery'
import { getRecurringInvoiceDeliveryLabel } from '@features/recurringInvoices/utils/getRecurringInvoiceDeliveryLabel'

import { useRecurringInvoiceForm } from '../../../../../../../../contexts/recurringInvoiceFormContext'

export const Delivery = () => {
  const { t } = useTranslation()
  const { recurringInvoiceForm } = useRecurringInvoiceForm()

  const { FormItem } = recurringInvoiceForm

  const items: NavItem<RecurringInvoiceDelivery>[] = useMemo(() => {
    return Object.values(RecurringInvoiceDelivery).map((delivery) => ({
      id: delivery,
      value: delivery,
      children: getRecurringInvoiceDeliveryLabel(delivery, t),
    }))
  }, [t])

  return (
    <FormItem
      name="delivery"
      label={t('external_invoices.editor.form.recurring_invoice_settings.field.delivery.label')}
      render={({ field: { onChange, value, ...props } }) => (
        <Select {...props} dropdownSize="xl" items={items} onSelect={onChange} selectedId={value} size="sm" />
      )}
    />
  )
}
